export default __webpack_public_path__ + "static/media/eth-price.69eef1c3.svg";